import basic from './basicComponents/index'
import biz from './bizComponents/index'
// export default {...basic,...biz}
const namespace = 'common'
const components = {...basic, ...biz}
const install = function (Vue) {
    // eslint-disable-next-line no-debugger
    // 遍历注册全局组件
    Object.keys(components).map(e => {
        Vue.component(namespace+'-' + e, components[e]);
    });
}
/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}
export default {
    install
}